import { LANGS, useI18n } from '../lib/i18n';

/** Til almashtirgich: UZ / RU. Tanlov brauzerda saqlanadi. */
export function LangSwitch() {
  const { lang, setLang, t } = useI18n();

  return (
    <div className="segmented segmented--sm" role="radiogroup" aria-label={t('lang.aria')}>
      {LANGS.map((code) => (
        <button
          key={code}
          type="button"
          role="radio"
          aria-checked={lang === code}
          title={t(`lang.${code}`)}
          className={`segmented__btn ${lang === code ? 'is-active' : ''}`}
          onClick={() => setLang(code)}
        >
          {code.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
